import * as React from 'react';

const Lv16 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 16 16", width: 16, height: 16, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#9D2235", d: "M1 9h14v2a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2z" }), /* @__PURE__ */ React.createElement("path", { fill: "#F1F2F1", d: "M1 7.006h14v1.988H1z" }), /* @__PURE__ */ React.createElement("path", { fill: "#9D2235", d: "M1 5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2l.004 2h-14z" }));
Lv16.Size = 16;
Lv16.Title = "Lv";

export { Lv16 as default };
